import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BrandCodes, BrandName } from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DwoCheckListRequestModel } from '../../business-entities/dwo-check-list-request-model';
import { DwoSubCheckListDetailViewModel } from '../../business-entities/dwo-sub-check-list-detail-view-model';
import { DwoSubCheckListViewModel } from '../../business-entities/dwo-sub-check-list-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { VehicleType } from '../../business-entities/vehicleTypes-model';
import { RentalCarService } from '../../business-services/rental-car.service';
import { GenericResponse } from './../../business-entities/generic-response';
import { CheckListBusinessService } from './../../business-services/check-list.service';
import { AddCheckListItemsComponent } from './add-check-list-items/add-check-list-items.component';
import { AddCheckListComponent } from './add-check-list/add-check-list.component';
import { Brand } from '../../business-entities/brand.model';
import { AddMulticplourChecklistItemComponent } from './add-multicplour-checklist-item/add-multicplour-checklist-item.component';
import { Features } from '../../business-entities/user-role-view-model';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-check-list-management',
  templateUrl: './check-list-management.component.html',
  styleUrls: ['./check-list-management.component.css']
})
export class CheckListManagementComponent implements OnInit, OnDestroy {

  checkList: DwoSubCheckListViewModel[];
  total$: Observable<number>;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  selectedBrand: string = null;
  selectedVehicleType: string = null;
  vehicleType: VehicleType[];
  vehicleTypeList: VehicleType[] = [];
  brandList: Brand[] = [];
  brand: Brand[];
  genericVehicleType: VehicleType = { id: 0, name: "All Vehicle Types", code: "ALL", isDisplay: true };
  paginationSub: Subscription
  currentlagSub: Subscription
  currentUser: string
  dwoCheckListRequestModel: DwoCheckListRequestModel = {
    Id: 0,
    BrandId: "",
    VehicleTypeId: "",
    LangCode: "en-US",
    ClType: 1,
    Zident: ""
  };
  popupCloseResult = false;
  userRoleRightsDetails: UserRoleMenu;
  featureList: Features[] = [];
  showPredefinedChecklist: boolean = false;

  constructor(
    public pService: CustomPaggerService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private getAllBrandData: RentalCarService,
    private currentLanguageService: CurrentLanguage,
    private checkListBusinessService: CheckListBusinessService,
    private userService: UserDataService,
    config: NgbModalConfig,
  ) {

    this.pService.pageSize = 10;
    this.pService.searchby = ['subCheckListTitle', 'checkListDescription', 'brand', 'vehicleType'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.ChecklistManagement);
    this.pService.dataSource = [];
    if (this.checkListBusinessService.selectedBrand && this.checkListBusinessService.selectedVehicleType && this.checkListBusinessService.isEdit) {
      this.selectedBrand = this.checkListBusinessService.selectedBrand;
      this.selectedVehicleType = this.checkListBusinessService.selectedVehicleType;
      this.checkListBusinessService.isEdit = false
    }
    if (this.checkListBusinessService.selectedBrand && this.checkListBusinessService.isEdit) {
      this.selectedBrand = this.checkListBusinessService.selectedBrand;
      this.checkListBusinessService.isEdit = false
    }
    if (this.checkListBusinessService.selectedVehicleType && this.checkListBusinessService.isEdit) {
      this.selectedVehicleType = this.checkListBusinessService.selectedVehicleType;
      this.checkListBusinessService.isEdit = false
    }
    this.checkList = []
    this.getVehicleData();
    this.GetAllBrand();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      //this.language = x
      this.dwoCheckListRequestModel.LangCode = x;
      this.onSelect();

    });
    this.currentLanguageService.featureList.subscribe(res => {
      this.featureList = res;
      if (this.featureList && this.featureList.length > 0) {
        this.showPredefinedChecklist = this.featureList.find(x => x.featureCode === Enums.FeatureCode.PredefinedChecklist)?.isActive;
        this.checkListBusinessService.showPredefinedChecklist = this.showPredefinedChecklist;
      }
    });
  }

  async getVehicleData() {
    await this.GetAllVehicleType();
  }

  async GetAllVehicleType() {
    this.vehicleTypeList.push(this.genericVehicleType);
    await this.checkListBusinessService.getVehicleTypes().then(data => {
      this.vehicleType = data.responseObject.filter(x => x.isDisplay);
      for (let value of this.vehicleType) {
        this.vehicleTypeList.push(value)
      }
    })
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand){
        this.brandList.push(value)
      }
    })
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  getCheckList(param: DwoCheckListRequestModel) {
    this.spinner.show();
    this.checkListBusinessService.getCheckList(param).then((response: GenericResponse<DwoSubCheckListDetailViewModel>) => {
      this.pService.dataSource = response.responseObject.dwoSubCheckList;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.checkList = this.ServiceDataMapper(result);
      });
      this.spinner.hide();
    });
  }

  private ServiceDataMapper(service: any) {
    let supperArray = [];
    if (service && service.length > 0) {

      for (let index = 0; index < service.length; index++) {
        const element = service[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
          single.subCheckListTitle = element.subCheckListTitle;
          single.checkListDescription = element.checkListDescription;
          single.checkListItems = element.checkListItems;
          single.brand = this.findBrand(element.brand);
          single.logo = element.brand.trim();
        single.vehicalType = element.vehicleType;
        single.isMulticolorCheckListSelected = element.isMulticolorCheckListSelected;
        single.colourCheckListType = element.colourCheckListType;
        supperArray.push(single);
      }
    }

    return supperArray;
  }

  findBrand(brandcode: string) {
    if (brandcode.trim() === BrandCodes.BMW) {
      return BrandName.BMW
    }
    if (brandcode.trim() === BrandCodes.Mercedes) {
      return BrandName.MER
    }
    if (brandcode.trim() === BrandCodes.Citroën) {
      return BrandName.CIT
    }
    if (brandcode.trim() === BrandCodes.Peugeot) {
      return BrandName.PEU
    }
    if (brandcode.trim() === BrandCodes.Kia) {
      return BrandName.KIA
    }
    if (brandcode.trim() === BrandCodes.Audi) {
      return BrandName.AUD
    }
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  editCheckList(chkList: any) {
    this.checkListBusinessService.checkListId = chkList.id;
    this.checkListBusinessService.multiColorSelect = chkList.isMulticolorCheckListSelected;
    this.checkListBusinessService.duplicateChecklist = false;
    const modalref = this.modalService.open(AddCheckListComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((res) => {
      if (res.success) {
        this.ngOnInit();
      }
    });
  }

  duplicateCheckList(chkList: any) {
    this.checkListBusinessService.checkListId = chkList.id;
    this.checkListBusinessService.duplicateChecklist = true;
    this.checkListBusinessService.multiColorSelect = chkList.isMulticolorCheckListSelected;
    this.checkListBusinessService.colourCheckListType = chkList.colourCheckListType;
    const modalref = this.modalService.open(AddCheckListComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((resp) => {
      if (resp.success) {
        this.ngOnInit();
      }
    });
  }

  viewCheckList(id: number) {
    this.router.navigate(['/checklist/view', id]);
  }
  editCheckListItem(check: any, id: number) {
    this.checkListBusinessService.check = check.subCheckListTitle.toString();
    this.checkListBusinessService.IsAddItems = '0'
    this.checkListBusinessService.checkListItemId = id;
    const modalref = this.modalService.open(AddCheckListItemsComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((respons) => {
      if (respons.success) {
        this.ngOnInit();
      }
    });
  }
  onAdd() {
    this.checkListBusinessService.checkListId = 0;
    this.checkListBusinessService.multiColorSelect = false;
    const modalref = this.modalService.open(AddCheckListComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((responce) => {
      if (responce.success) {
        this.ngOnInit();
      }
    });
  }
  onAdditem(item: any, multicolor: any) {
    if (multicolor) {
      this.checkListBusinessService.check = item.subCheckListTitle.toString();
      this.checkListBusinessService.IsAddItems = '1';
      this.checkListBusinessService.multiColorSelect = true ;
      this.checkListBusinessService.checkListItemId = item.id;
      this.checkListBusinessService.checkListItemData = item;
      const modalref = this.modalService.open(AddMulticplourChecklistItemComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });

    }
    else {
      this.checkListBusinessService.check = item.subCheckListTitle.toString();
      this.checkListBusinessService.IsAddItems = '1'
      this.checkListBusinessService.checkListItemId = item.id;
      const modalref = this.modalService.open(AddCheckListItemsComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((responses) => {
        if (responses.success) {
          this.ngOnInit();
        }
      });
    }

  }

  deleteCheckList(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblCheckList"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.currentUser = this.userService.currentUserValue.userId;
        let deleteRequestModel = { id: id, UserId: this.currentUser };
        this.checkListBusinessService.deleteCheckList(deleteRequestModel).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblCheckListDeleted");
            this.toastr.success(successMsg)
            this.onSelect();
          }
        });
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  onSelect() {
    if (this.selectedBrand === null && this.selectedVehicleType === null) this.getCheckList(this.dwoCheckListRequestModel);
    else if (this.selectedBrand != null || this.selectedVehicleType != null) {
      this.checkListBusinessService.selectedBrand = this.selectedBrand;
      this.checkListBusinessService.selectedVehicleType = this.selectedVehicleType;
      this.checkList = []
      this.dwoCheckListRequestModel.BrandId = this.selectedBrand;
      this.dwoCheckListRequestModel.VehicleTypeId = this.selectedVehicleType;
      this.getCheckList(this.dwoCheckListRequestModel);
    } else {
      this.pService.dataSource = []
    }
  }

  onBrandSelect() {
    if (this.selectedBrand === null) {
      this.checkListBusinessService.selectedBrand = null;
      this.dwoCheckListRequestModel.BrandId = null;
      this.getCheckList(this.dwoCheckListRequestModel);
    }
    else if (this.selectedBrand != null) {
      this.checkListBusinessService.selectedBrand = this.selectedBrand;
      this.checkListBusinessService.selectedVehicleType = this.selectedVehicleType;
      this.checkList = []
      this.dwoCheckListRequestModel.BrandId = this.selectedBrand;
      this.dwoCheckListRequestModel.VehicleTypeId = this.selectedVehicleType;
      this.getCheckList(this.dwoCheckListRequestModel);
    } else {
      this.pService.dataSource = []
    }
  }

  onVehicleTypeSelect() {
    if (this.selectedVehicleType === null) {
      this.checkListBusinessService.selectedVehicleType = null;
      this.dwoCheckListRequestModel.VehicleTypeId = null;
      this.getCheckList(this.dwoCheckListRequestModel);
    }
    else if (this.selectedVehicleType != null) {
      this.checkListBusinessService.selectedBrand = this.selectedBrand;
      this.checkListBusinessService.selectedVehicleType = this.selectedVehicleType;
      this.checkList = []
      this.dwoCheckListRequestModel.BrandId = this.selectedBrand;
      this.dwoCheckListRequestModel.VehicleTypeId = this.selectedVehicleType;
      this.getCheckList(this.dwoCheckListRequestModel);
    } else {
      this.pService.dataSource = []
    }
  }

}

